import React from "react";
import { Switch, Route, BrowserRouter } from "react-router-dom";

import HomePage from "../../pages/homepage";
import States from "../../pages/state";
import Districts from "../../pages/district";
import Leads from "../../pages/leads";
// require('dotenv').config();

function App() {
  return (
    <div>
      <BrowserRouter>
        <Switch>
          <Route exact path="/leads" render={props => <Leads {...props} />} />
          <Route
            exact
            path="/:state"
            render={props => {
              return <States {...props} />;
            }}
          />
          <Route
            exact
            path="/:state/:district"
            render={props => <Districts {...props} />}
          />
          <Route exact path="/" component={HomePage} />
          {/* <Route component={NotFoundPage} /> */}
        </Switch>
      </BrowserRouter>
      {/* <GlobalStyle /> */}
    </div>
  );
}

export default App;
